<template>
  <div v-if="isShow.isPOShow" class="po">
    <div class="po-title-wp">
      <div class="po-title"></div>
      <div class="po-title-sub">
        <img src="./img/po-title-sub-inner.png" alt="">
      </div>
    </div>
    <div class="po-article"></div>
    <div class="po-article2">
      <div class="po-article2-c1"></div>
      <div class="po-article2-c2"></div>
    </div>
    <div class="po-bg-bottom">
      <div class="po-bg-wires" :style="`transform: scale(${scaleSize})`">
        <div class="po-bg-wires-inner"></div>
      </div>
      <div class="po-bg-bottom-inner">
        <div class="btn-group">
          <div class="btn1" @click="showNextP2">
            <div class="btn1-inner"></div>
          </div>
          <div class="btn2" @click="showNextP3">
            <div class="btn2-inner"></div>
          </div>
          <div class="btn3" @click="showNextP4">
            <div class="btn3-inner"></div>
          </div>
          <div class="btn4" @click="showNextP5">
            <div class="btn4-inner"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageOne',
  props: {
    isShow: Object
  },
  data() {
    return {
      scaleSize: 0.5
    }
  },
  mounted() {
    const w = window.innerWidth;
    this.scaleSize = w / 750;
  },
  methods: {
    showNextP2 () {
      setTimeout(() => {
        this.$emit('nextPage', 'isPTShow');
      }, 200);
    },
    showNextP3 () {
      setTimeout(() => {
        this.$emit('nextPage', 'isPHShow');
      }, 200);
    },
    showNextP4 () {
      setTimeout(() => {
        this.$emit('nextPage', 'isPFShow');
      }, 200);
    },
    showNextP5 () {
      setTimeout(() => {
        this.$emit('nextPage', 'isPVShow');
      }, 200);
    },
  },
  watch: {
    'isShow.isPOShow': function () {
      window.scroll(0, 0);
    }
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.po {
  min-height: 100vh;
  background-color: #0f2e8f;
}
.po-title-wp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 45/2rem /* 720/16 */;
  height: 38.75/2rem /* 620/16 */;
  margin: 0 auto;
  .bg('./img/po-bg-top.png');
}
.po-title {
  margin-bottom: 3.125rem /* 50/16 */;
  width: 24.875/2rem /* 398/16 */;
  height: 14.875/2rem /* 238/16 */;
  .bg('./img/po-title.png');
}
.po-title-sub {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('./img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 11.6875/2rem /* 187/16 */;
    height: 1.25rem /* 20/16 */;
  }
}
.po-article {
  width: 42.8125/2rem /* 685/16 */;
  height: 108.125/2rem /* 1730/16 */;
  margin: 0 auto;
  .bg('./img/po-article.png');
}
.po-article2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 3.125rem /* 50/16 */;
  width: 42.8125/2rem /* 685/16 */;
  height: 72.5625/2rem /* 1161/16 */;
  margin: 0 auto;
  margin-top: 3.125rem /* 50/16 */;
  .bg('./img/po-article2-bg.png');
}
.po-article2-c1 {
  width: 40.4375/2rem /* 647/16 */;
  height: 22.6875/2rem /* 363/16 */;
  .bg('./img/po-article2-c1.png');
}
.po-article2-c2 {
  width: 40.4375/2rem /* 647/16 */;
  height: 32.875/2rem /* 526/16 */;
  .bg('./img/po-article2-c2.png');
}
.po-bg-bottom {
  position: relative;
  width: 46.875/2rem /* 750/16 */;
  height: 92.5/2rem /* 1480/16 */;
  background: linear-gradient(to bottom, #0f2e8f 1%, #9959c9 20%, #ed7ae7 50%, #ffacd1 98%);
}
.po-bg-wires {
  position: absolute;
  bottom: 0;
  left: 0;
  transform-origin: left bottom;
  z-index: 2;
}
.po-bg-wires-inner {
  width: 750px;
  height: 1449px;
  background-repeat: no-repeat;
  background-image: url('./img/pg1-bottom-bg.png');
  background-position-x: 0;
  animation: wireAni 4s steps(10) infinite;
}
.po-bg-bottom-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  .bg('./img/po-bg-bottom.png');
}
.btn-group {
  position: relative;
  z-index: 5;
}
.btn1, .btn2, .btn3, .btn4 {
  width: 19.375/2rem /* 310/16 */;
  height: 18.125/2rem /* 290/16 */;
  transition: opacity .3s;
  &:active {
    opacity: .6;
  }
}
.btn1 {
  position: absolute;
  top: 4rem;
  left: 2rem;
  width: 297px;
  height: 265px;
  transform-origin: top left;
  transform: scale(0.6);
  animation: planetFloat 4s ease-in-out alternate infinite;
}
.btn1-inner {
  width: 100%;
  height: 100%;
  background-image: url('./img/planet1.png');
  background-repeat: no-repeat;
  animation: planetAni1 1.5s steps(10) infinite;
}
.btn2 {
  position: absolute;
  top: 12rem;
  right: 0;
  width: 189px;
  height: 133px;
  transform-origin: top right;
  animation: planetFloat2 4s ease-in-out alternate infinite;
  animation-delay: -1s;
}
.btn2-inner {
  width: 100%;
  height: 100%;
  background-image: url('./img/planet2.png');
  background-repeat: no-repeat;
  animation: planetAni2 1.5s steps(11) infinite;
}
.btn3 {
  position: absolute;
  top: 21rem;
  left: 2rem;
  width: 332px;
  height: 253px;
  transform-origin: top left;
  animation: planetFloat3 4s ease-in-out alternate infinite;
}
.btn3-inner {
  width: 100%;
  height: 100%;
  background-image: url('./img/planet3.png');
  background-repeat: no-repeat;
  animation: planetAni3 1.5s steps(10) infinite;
  animation-delay: -1s;
}
.btn4 {
  position: absolute;
  right: 0rem;
  top: 28rem;
  width: 212px;
  height: 141px;
  transform-origin: top right;
  animation: planetFloat4 4s ease-in-out alternate infinite;
}
.btn4-inner {
  width: 100%;
  height: 100%;
  background-image: url('./img/planet4.png');
  background-repeat: no-repeat;
  animation: planetAni4 1.5s steps(11) infinite;
}
@keyframes wireAni {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -7500px;
  }
}
@keyframes planetAni1 {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -2970px;
  }
}
@keyframes planetAni2 {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -2079px;
  }
}
@keyframes planetAni3 {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -3320px;
  }
}
@keyframes planetAni4 {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -2332px;
  }
}
@keyframes titleAni {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -3663px;
  }
}
@keyframes planetFloat {
  from {
    transform: translateY(-10px) scale(.6);
  }
  to {
    transform: translateY(0) scale(.6);
  }
}
@keyframes planetFloat2 {
  from {
    transform: translateY(-10px) scale(.9);
  }
  to {
    transform: translateY(0) scale(.9);
  }
}
@keyframes planetFloat3 {
  from {
    transform: translateY(-10px) scale(.48);
  }
  to {
    transform: translateY(0) scale(.48);
  }
}
@keyframes planetFloat4 {
  from {
    transform: translateY(-10px) scale(.85);
  }
  to {
    transform: translateY(0) scale(.85);
  }
}
</style>
